import {IStore} from "modules/types/store";

export const getContactState = (state: IStore) => state.contact.requestState;
